import { type IFieldCustomValue } from '@inpart-io/padme-iap';

import { ObligationInstanceDateTypes } from '@/constants/ui/obligation.constants';

export class StringService {
    public cleanText(text: string): string {
        if (text) {
            return text.toLowerCase().trim().replace(/( +)/g, ' ');
        }
        return text;
    }

    public transformRegexInDays(text: string): { nb: number; type: IFieldCustomValue } {
        const nb = parseInt(text.match(/\d/g).join(''), 10);

        const type = ObligationInstanceDateTypes.filter((dateType: IFieldCustomValue) => {
            return dateType.value === text.substring(text.length - 1);
        })[0];

        return { nb, type };
    }
}

export const stringService = new StringService();
